// This action is more complex than what its name suggests.
// It only removes a single domain if it is passed as an argument,
// otherwise it removes the addon from all domains in the cart.

import {
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_LOADED,
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
  GET_CART_FAILURE,
} from "../../constants";
import { createAction, createErrorAction } from "../../utils";
import { getCartItems, getCartPrice } from "../../selectors";
import showError from "../showError/showError";
import { registerGTMEvent } from "../registerGTMEvent/registerGTMEvent";

// Cart
const getCartRequest = createAction(GET_CART_REQUEST);
const getCartSuccess = createAction(GET_CART_SUCCESS);
const getCartFailure = createErrorAction(GET_CART_FAILURE);
const setProductsLoading = createAction(GET_PRODUCTS_REQUEST);
const setProductsLoaded = createAction(GET_PRODUCTS_LOADED);

export const removeAddonProductFromDomain = ({
  addonProductId,
  domainToBeRemoved = false,
  // location, // unused for GTM at the moment
  finalCartLineIndex,
}) => {
  return async (dispatch, getState, { api }) => {
    // Load requests
    dispatch(getCartRequest());
    dispatch(setProductsLoading());

    const state = getState();
    const cartPrice = getCartPrice(state);
    const cartItems = getCartItems(state);
    const domainsInCart = cartItems.map((item) => item.fullDomain);

    let responseData = {
      getCart: false,
    };

    let domainsToRemoveAddonProductFor = [];

    if (!domainToBeRemoved) {
      // Remove addon for all domains
      domainsToRemoveAddonProductFor = domainsInCart;
    } else {
      // Remove addon for domain passed to this action
      domainsToRemoveAddonProductFor.push(domainToBeRemoved);
    }

    const index1Based =
      typeof finalCartLineIndex === "number"
        ? finalCartLineIndex + 1 // making it 1-based
        : finalCartLineIndex; // may be null if triggered from outside of cart

    dispatch(
      registerGTMEvent.removeFromCart({
        product: addonProductId,
        type: "addonProduct",
        currency: cartPrice.currency,
        // location: location || "In-cart upsell", // unused for GTM at the moment
        index: index1Based,
      }),
    );

    for (const domain of domainsToRemoveAddonProductFor) {
      const domainAddons = cartItems.find(
        (cartItem) => cartItem.fullDomain === domain,
      ).addonProducts;

      // Check if domain still contains addon
      if (domainAddons.includes(addonProductId)) {
        await api.removeAddonProduct(addonProductId, domain).then(
          (data) => {},
          (err) => {
            dispatch(showError("default"));
            console.error("Add addonproducts failed", err);
          },
        );
      }
    }

    // Get the updated cart
    await api.getCart().then(
      (data) => {
        responseData.getCart = data;
      },
      (err) => {
        console.error("Get cart failed", err);
        dispatch(showError("cartUpdateFailed"));
        dispatch(getCartFailure(err));
      },
    );

    if (responseData.getCart) {
      dispatch(getCartSuccess(responseData.getCart));
    }
    dispatch(setProductsLoaded());
  };
};
